import script from "./ModButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ModButton.vue?vue&type=script&setup=true&lang=js"

import "./ModButton.vue?vue&type=style&index=0&id=74c4aabe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74c4aabe"]])

export default __exports__